import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const scheduleTypes = ["SCHEDULED_ONCE", "RECURRING"];

const schema = yup.object({
  delivery_type: yup.string().optional(),

  start_date: yup.string().when("delivery_type", {
    is: (val) => scheduleTypes.includes(val),
    then: (schema) => schema.required("Start date is required"),
    otherwise: (schema) => schema.optional(),
  }),

  time: yup.string().when("delivery_type", {
    is: (val) => scheduleTypes.includes(val),
    then: (schema) => schema.required("Time is required"),
    otherwise: (schema) => schema.optional(),
  }),
});

const useValidation = ({ ...formData }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formData,
    },
  });
};

export default useValidation;
